module.exports = {
  email: 'aniketbiswas100@gmail.com',
  mediumUsername: 'aniketbiswas',

  socialMedia: [
    {
      name: 'GitHub',
      url: 'https://github.com/aniketbiswas',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/aniketbiswas/',
    },
    {
      name: 'LeetCode',
      url: 'https://leetcode.com/aniketbiswas100/',
    },
    // {
    //   name: 'Twitter',
    //   url: 'https://twitter.com/aniket__biswas',
    // },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Writing',
      url: '/#blogs',
    },
    {
      name: 'Certifications',
      url: '/#certifications',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  colors: {
    green: '#2457f5',
    navy: '#f3f1eb',
    darkNavy: '#eae7df',
  },
};
